module.exports = __webpack_public_path__ + "static/media/02.e2077896.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/volumetric/baggage/02.png
// module id = 636
// module chunks = 0